module.exports = __webpack_public_path__ + "static/mockup-5d308b6551e798b1588702f738d23b83.svg";